import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/p/:slug/dashboard',
		buildUrl: ({ path, queryString }) => `${path}/home${queryString}`,
	},
];
